enum PlatformConstants {
  GET_PLATFORMS_LIST = "GET_PLATFORMS_LIST",
  GET_PLATFORMS_LIST_SUCCESS = "GET_PLATFORMS_LIST_SUCCESS",
  GET_PLATFORMS_LIST_FAILURE = "GET_PLATFORMS_LIST_FAILURE",

  CREATE_PLATFORM_REQUEST = "CREATE_PLATFORM_REQUEST",
  CREATE_PLATFORM_SUCCESS = "CREATE_PLATFORM_SUCCESS",
  CREATE_PLATFORM_FAILURE = "CREATE_PLATFORM_FAILURE",

  EDIT_PLATFORM_REQUEST = "EDIT_PLATFORM_REQUEST",
  EDIT_PLATFORM_SUCCESS = "EDIT_PLATFORM_SUCCESS",
  EDIT_PLATFORM_FAILURE = "EDIT_PLATFORM_FAILURE",

  RESET_PLATFORM_REQUEST = "RESET_PLATFORM_REQUEST",
  RESET_PLATFORM_LIST = "RESET_PLATFORM_LIST",
}

export default PlatformConstants;
